import { render, staticRenderFns } from "./CustomersView.vue?vue&type=template&id=33da8793&scoped=true"
import script from "./CustomersView.vue?vue&type=script&lang=js"
export * from "./CustomersView.vue?vue&type=script&lang=js"
import style0 from "./CustomersView.vue?vue&type=style&index=0&id=33da8793&prod&scoped=true&lang=css"
import style1 from "./CustomersView.vue?vue&type=style&index=1&id=33da8793&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33da8793",
  null
  
)

export default component.exports